import styled, { css } from 'styled-components'

export const SelectFake = styled.div`
  position: relative;
  width: fit-content;
  block-size: fit-content;
  cursor: pointer;

  select {
    display: none;
  }

  div {
    font-weight: bold;
    color: var(--theme-primary);

    &:after {
      position: absolute;
      content: '';
      top: 10px;
      right: -20px;
      width: 0;
      height: 0;
      border: 6px solid transparent;
      border-color: #000 transparent transparent transparent;
    }

    ${({ active }) => css`
      ${active &&
      css`
        ul {
          display: block;
        }
        &:after {
          border-color: transparent transparent #000 transparent;
          top: 4px;
        }
      `}
    `}
  }
`

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;

  label {
    font-weight: lighter;
    font-size: var(--font-size-md);
    color: var(--text-tertiary);
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 8px;

    &:after {
      content: '';
      display: inline-block;
      height: 12px;
      width: 2px;
      background: var(--text-tertiary);
      opacity: 0.42;
    }
  }
`

export const OptionsFake = styled.ul`
  display: none;
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  z-index: 99;

  ${({ active }) => css`
    ${active &&
    css`
      display: block;
      border: 1px solid #dfe6f1;
      padding: 5px;
      background: #fff;
      width: 120%;
      li {
        font-size: var(--font-size-ssm);
        color: var(--text-tertiary);
        text-align: left;
        padding: 10px;

        &:hover {
          background-color: #dfe6f1;
          color: var(--text-dark);
        }
      }
    `}
  `}
`
